import {
  SUPPORT_TICKET_STATUSES,
  type SupportTicketStatus,
} from "@redotech/effect-api-shared/models/shopper-ai/conversation/support-ticket";
import {
  SupportTicketFilterNames,
  supportTicketFilterData,
} from "@redotech/effect-api-shared/schema/support-ticket-filters";
import StatusIcon from "@redotech/redo-icons/status.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import type { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { SupportTicketStatusReadable } from "../ui/support-ticket-status-ui";

const EXCLUDED_STATUSES = new Set<SupportTicketStatus>([
  "HIDDEN",
  "ARCHIVED",
  "DELETED",
]);

const FILTERABLE_STATUSES = SUPPORT_TICKET_STATUSES.filter(
  (
    status,
  ): status is Exclude<
    SupportTicketStatus,
    "HIDDEN" | "ARCHIVED" | "DELETED"
  > => !EXCLUDED_STATUSES.has(status),
);

export const StatusAdvancedFilter: ArrayStringTableFilter<SupportTicketStatus> =
  {
    type: AdvancedFilterType.ARRAY_TO_STRING,
    Icon: StatusIcon,
    operators: [
      ArrayStringFilterOperator.ANY_OF,
      ArrayStringFilterOperator.NONE_OF,
    ],
    data: supportTicketFilterData[SupportTicketFilterNames.STATUS],
    itemLabel: "status",
    itemLabelPlural: "statuses",
    values: FILTERABLE_STATUSES,
    display: (item: SupportTicketStatus) =>
      SupportTicketStatusReadable[item] ?? item,
    displayName: "Status",
  };
